<template>
  <el-row type="flex" justify="space-between" align="middle" class="wrapper">
    <slot></slot>
    <slot name="right">
      <Button v-if="showAddBtn" type="add" @click="handleAddEducation"
        >添加</Button
      >
    </slot>
  </el-row>
</template>

<script>
import Button from "@/components/Button.vue";

export default {
  components: {
    Button,
  },

  props: {
    showAddBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleAddEducation() {
      this.$emit("add");
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  @extend .f18;
  padding: 0 30px;
  height: 49px;
  font-weight: 600;
  color: $primary-color;
  background: #e5eefc;
}
</style>